/**
 * Input Group Label Component
 * Responsible for showing input level errors specific to a particular field
 *
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-input-group-label',
  template: '<ng-content />',
  styleUrls: ['input-group-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputGroupLabelComponent {
}
